<template>
  <div>
    <QuickFixDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      isCardColor="true"
      @register="register"
    >
      <template v-slot:[pageData[0].name]>
        <div class="px-7">
          <v-container fluid>
            <v-row no-gutters class="pa-1">
              <v-col cols="6">
                <InputFormNew
                  :heading="$t('storage.storage_storage-move-info')"
                  v-model="pageInfoData.line1"
                  :detail="pageInfoDetail.line1"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                </InputFormNew>
              </v-col>
              <v-col cols="6">
                <InputFormNew
                  :heading="$t('common.input_recipient-info')"
                  v-model="pageInfoData.line2"
                  :detail="pageInfoDetail.line2"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                  <template #postalCode>
                    <!-- 郵便番号 -->
                    <PostalCodeArea
                      v-model="pageInfoData.line2.postalCode"
                      :height="inputFormStyle.inputItemHeight"
                      :countryId="pageInfoData.line2.country.value"
                      @click="getAddressFromPostalCode"
                    />
                  </template>
                </InputFormNew>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
    </QuickFixDialogBase>
  </div>
</template>
<script>
import QuickFixDialogBase from './QuickFixDialogBase'

import { mapActions } from 'vuex'
import {
  commonUtil,
  countryCallingCodeUtil,
  countryUtil,
  storageUtil
} from '@/util'
import { InputFormNew, PostalCodeArea } from '@/components/items'

export default {
  components: {
    QuickFixDialogBase,
    InputFormNew,
    PostalCodeArea
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [],
    pageInfoData: {},

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },
    pageInfoDetail: {
      line1: [
        {
          name: 'controlNumber',
          text: 'stock-adjust.stock-adjust_stock-adjust-control-number',
          component: 'text'
        },
        {
          name: 'storageName',
          text: 'stock-adjust.stock-adjust_stock-adjust_adjustment-warehouse',
          component: 'text'
        },
        {
          name: 'adjustDate',
          text: 'stock-adjust.stock-adjust_adjustment-date',
          component: 'text'
        },
        {
          name: 'trackingNumber',
          text: 'ship.ship_tracking-number',
          cols: 8
        },
        {
          name: 'storageAdjustReasonId',
          text: 'stock-adjust.stock-adjust_inventory-adjustment-reason',
          required: true,
          component: 'SelectStockAdjustReason',
          cols: 8
        },
        {
          name: 'target',
          text: 'stock-adjust.stock-adjust_target-require-present',
          cols: 8
        }
      ],
      line2: [
        {
          name: 'fullName',
          text: 'common.input_name'
        },
        {
          name: 'phone',
          text: 'common.input_phone-number',
          component: 'PhoneNumberInput'
        },
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectCountry'
        },
        {
          name: 'postalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil((12 - 3) / 2)
        },
        {
          name: 'region',
          text: 'common.input_region',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectRegion'
        },
        {
          name: 'address1',
          text: 'common.input_address_1'
        },
        {
          name: 'address2',
          text: 'common.input_address_2'
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Stock', ['editStockAdjust']),
    ini() {
      this.pageData = [
        {
          title: 'storage.storage_stock-adjust-info',
          name: 'stockAdjustInfo',
          items: [],
          itemKey: ''
        },
        {
          title: `${this.$t('storage.storage_storage-move-detail')}（${
            storageUtil.getStorageById(this.recItems.adjustStorageId).name
          } ）`,
          name: 'stockAdjustDetail',
          productHeaders: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '135px',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '705px',
              class: 'rgba(151, 198, 234, 0.1)'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '120px',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'storage.storage_stock-adjustt-quantity-rack-number',
              value: 'quantityAndStorageNoForStockAdjust',
              sortable: false,
              width: '150px',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            }
          ],
          itemKey: 'stockAdjustId',
          items: this.recItems.productMoves
        }
      ]

      // console.log(items)

      this.pageInfoData = {
        line1: {
          controlNumber: this.recItems.transaction.controlNumber,
          storageName: storageUtil.getStorageById(this.recItems.adjustStorageId)
            .name,
          adjustDate: this.recItems.stockAdjustDate,
          trackingNumber: this.recItems.trackingNumber,
          storageAdjustReasonId: {
            value: this.recItems.adjustReasonId
          },
          target: this.recItems.target
        },
        line2: {
          fullName: this.recItems.recipientName,
          // companyName: "",
          phone: {
            // TODO：APIのレスポンスはcodeで良いか
            countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
              this.recItems.recipientPhoneNumberCountryId
            ),
            phoneNumber: this.recItems.recipientPhoneNumber
          },
          country: countryUtil.getCountryIdInfo(
            this.recItems.recipientCountryId
          ),
          postalCode: this.recItems.recipientPostalCode,
          // TODO：入力欄を動的にする
          region: countryUtil.getRegionInfo(
            this.recItems.recipientCountryId,
            this.recItems.recipientRegionId
          ),
          address1: this.recItems.recipientAddress1,
          address2: this.recItems.recipientAddress2
        }
      }
    },
    getAddressFromPostalCode(...args) {
      const [address] = args

      this.pageInfoData.line2.region = countryUtil.getRegionInfoByName(
        this.pageInfoData.line2.country.value,
        address.region
      )
      this.pageInfoData.line2.address1 = address.locality
      this.pageInfoData.line2.address2 = address.street
    },
    getInputValue() {
      return {
        stockAdjustId: this.recItems.stockAdjustId,
        adjustReasonId: this.pageInfoData.line1.storageAdjustReasonId.value,
        target: this.pageInfoData.line1.target,
        trackingNumber: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line1.trackingNumber
        ),
        recipientName: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.fullName
        ),
        recipientCountryId: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.country.value
        ),
        recipientPostalCode: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.postalCode
        ),
        recipientRegionId: commonUtil.nullEmptyFormatNull(
          commonUtil.formatRegion(this.pageInfoData.line2.region, true)
        ),
        recipientRegion: commonUtil.nullEmptyFormatNull(
          commonUtil.formatRegion(this.pageInfoData.line2.region, false)
        ),
        recipientAddress1: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.address1
        ),
        recipientAddress2: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.address2
        ),
        recipientPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.phone.countryCode.value
        ),
        recipientPhoneNumber: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.phone.phoneNumber
        )
      }
    },
    async register() {
      const isConfirmed = confirm(this.$t('common.common_save-question'))
      if (!isConfirmed) return
      const inputValue = this.getInputValue()
      const isSucceed = await this.editStockAdjust(inputValue)
      if (isSucceed) {
        this.inputedValue.dialog = false
        this.$emit('dialogReload')
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
